/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Product_Stock_Discount_TierInputs */

const vi_product_stock_discount_tier = /** @type {(inputs: Product_Stock_Discount_TierInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CK ${i?.percent}%`)
};

/**

* @param {Product_Stock_Discount_TierInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_stock_discount_tier = /** @type {((inputs: Product_Stock_Discount_TierInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Stock_Discount_TierInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_stock_discount_tier(inputs)
});